<template>
    <v-row justify="center">
        <v-dialog v-model="showDialog" persistent max-width="700">
            <v-card v-bind:class="this.$store.state.user.currentUser.roles[0] === 'Staff' ? 'worker-map-location' : 'admin-map-location'">
                <v-card-title class="headline custom-card-header">Edit Task
                    <v-spacer></v-spacer>
                    <v-btn color="white" icon @click="toggle"><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <v-container>
                    <v-row>
                        <v-col xs="6">
                            <v-text-field outlined label="Task Type" v-model="jobTask.taskType"></v-text-field>
                        </v-col>
                        <v-col xs="6">
                            <v-autocomplete
                                label="Route"
                                outlined
                                :items="taskRoutes"
                                v-model="routeSelected"
                                hide-no-data
                                clearable
                                item-text="name"
                                item-value="id"
                                no-data-text="No routes available"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col xs="6">
                            <v-text-field outlined label="Notes" v-model="jobTask.notes"></v-text-field>
                        </v-col>
                        <v-col>
                            <div class="v-input v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
                                <div class="v-input__control">
                                    <div class="v-input__slot">
                                        <fieldset aria-hidden="true"><legend style="width: 45.25px; color:rgba(0, 0, 0, 0.6); font-size:12px;"><span>Address</span></legend></fieldset>
                                        <div class="v-text-field__slot">
                                            <vue-google-autocomplete
                                                id="details-edit"
                                                outlined
                                                ref="address"
                                                :value="jobTask.address"
                                                placeholder="Enter Address"
                                                :country="['can']"
                                                v-on:placechanged="getAddressData"
                                            ></vue-google-autocomplete>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                    <div v-if="disabled" class="text-center">
                        Saving<br />
                        <v-progress-circular
                            indeterminate
                            color="success"
                            v-if="disabled"
                        ></v-progress-circular>
                    </div>
                    <v-row v-if="errorMessage != null">
                        <v-col xs12><div class="text-center error--text success-message">{{errorMessage}}</div></v-col>
                    </v-row>
                    <v-card-actions>
                        <v-row>
                            <v-col xs="6">
                                <v-btn block depressed color="accent" @click="updateTask" :disabled="disabled">Update</v-btn>
                            </v-col>
                            <v-col xs="6">
                                <v-btn block depressed color="accent" outlined @click="openDetail" :disabled="disabled">Details</v-btn>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-container>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex'
    import VueGoogleAutocomplete from 'vue-google-autocomplete'
    export default {
        created() {
            this.getTaskNumbers()
            this.loadRoutes()
        },
        components: {
            VueGoogleAutocomplete
        },
        props: {
            showDialog: {
                type: Boolean,
                required: true
            },
            toggle: {
                type: Function,
                required: true
            },
            jobTask:{
                type: Object
            },
            openDetail: {
                type: Function,
                required: true
            }
        },
        data () {
            return {
                task: {},
                disabled: false,
                errorMessage: null,
                routeSelected: ''
            }
        },
        methods: {
            ...mapActions({
                update: 'jobTasks/update',
                loadRoutes: 'routes/getAll',
                loadAllRouteLocations: 'routes/getRouteAndLocations',
                getTaskNumbers: 'jobTasks/getTaskNumbers',
                loadTask: 'jobTasks/getById'
            }),
            async updateTask () {
                if(this.jobTask.taskType == null || this.jobTask.taskType === ''){
                    this.errorMessage = "Task Type cannot be empty"
                    return
                }
                this.errorMessage = null
                this.disabled = true
                this.jobTask.routeId = this.routeSelected
                await this.update(this.jobTask)
                if (!this.error) {
                    await this.loadAllRouteLocations()
                    await this.loadTask(this.jobTask.id)
                    await this.toggle()
                }
                this.disabled = false
            },
            getAddressData (addressData, placeResultData) {
                if(addressData == null) {
                    return;
                }
                this.jobTask.latitude = addressData.latitude
                this.jobTask.longitude = addressData.longitude
                this.jobTask.address = placeResultData.formatted_address
            },
        },
        computed: {
            ...mapGetters({
                taskRoutes: 'routes/routes',
                error: 'jobTasks/error'
            }),
        },
        watch: {
            jobTask (task) {
                if(task.route) {
                    this.routeSelected = task.route.id
                } else {
                    this.routeSelected = null
                }
                this.tagsSelected = []
                if(task.jobTaskTags && Array.isArray(task.jobTaskTags)){
                    task.jobTaskTags.forEach((jtt) =>{
                        if(!(jtt.tag && jtt.tag.name)){
                            return
                        }
                        this.tagsSelected.push(jtt.tag)
                    })
                }
                if(this.$refs && this.$refs.address) {
                    this.$refs.address.update(this.jobTask.address)
                }
            },
        }
    }
</script>
<style scoped>
    .custom-card-header {
        background-color: #00A5C5;
        color: white;
    }
    .worker-map-location {
        position: absolute;
        top: 5%;
        right:31%;
        max-width:700px
    }
    .admin-map-location {
        position: absolute;
        top: 5%;
        right:19%;
        max-width:700px
    }
</style>
